import { defineMessages } from 'react-intl';

const messages = defineMessages({
  active: {
    id: 'profiles.clientProfile.active',
    defaultMessage: 'Active',
  },
  activateRecurringAction: {
    id: 'profiles.clientProfile.activateRecurringAction',
    defaultMessage: 'Link card & activate',
  },
  activateRecurringSuccess: {
    id: 'profiles.clientProfile.activateRecurringSuccess',
    defaultMessage: 'Card linked — this membership is now billed to your card',
  },
  activateRemainingConfirm: {
    id: 'profiles.clientProfile.activateRemainingConfirm',
    defaultMessage: 'Activate all',
  },
  activateRemainingDescription: {
    id: 'profiles.clientProfile.activateRemainingDescription',
    defaultMessage:
      'Each one is charged to your saved card — right away if it has already started, otherwise on its first day.',
  },
  activateRemainingDismiss: {
    id: 'profiles.clientProfile.activateRemainingDismiss',
    defaultMessage: 'Not now',
  },
  activateRemainingTitle: {
    id: 'profiles.clientProfile.activateRemainingTitle',
    defaultMessage:
      '{count, plural, one {# more membership is} other {# more memberships are}} waiting for your card',
  },
  activateRemainingTotal: {
    id: 'profiles.clientProfile.activateRemainingTotal',
    defaultMessage: 'Total: {total}',
  },
  add: {
    id: 'profiles.clientProfile.add',
    defaultMessage: 'Add',
  },
  addMeal: {
    id: 'profiles.clientProfile.addMeal',
    defaultMessage: 'Add meal',
  },
  addNote: {
    id: 'profiles.clientProfile.addNote',
    defaultMessage: 'Add note / notification',
  },
  addNutritionPlan: {
    id: 'profiles.clientProfile.addNutritionPlan',
    defaultMessage: 'Add nutrition plan',
  },
  addPayment: {
    id: 'profiles.clientProfile.addPayment',
    defaultMessage: 'Add payment',
  },
  addPaymentTitle: {
    id: 'profiles.clientProfile.addPaymentTitle',
    defaultMessage: 'Record Payment',
  },
  addProgram: {
    id: 'profiles.clientProfile.addProgram',
    defaultMessage: 'Add program',
  },
  addToGroup: {
    id: 'profiles.clientProfile.addToGroup',
    defaultMessage: 'Add to group',
  },
  addToGroupTitle: {
    id: 'profiles.clientProfile.addToGroupTitle',
    defaultMessage: 'Add to group',
  },
  addTrainerNote: {
    id: 'profiles.clientProfile.addTrainerNote',
    defaultMessage: 'Add note',
  },
  addWorkout: {
    id: 'profiles.clientProfile.addWorkout',
    defaultMessage: 'Add workout',
  },
  adherence: {
    id: 'profiles.clientProfile.adherence',
    defaultMessage: 'Adherence',
  },
  archive: {
    id: 'profiles.clientProfile.archive',
    defaultMessage: 'Archive',
  },
  archiveClientDescription: {
    id: 'profiles.clientProfile.archiveClientDescription',
    defaultMessage: 'Hide from active lists. You can restore them later.',
  },
  archiveClientTitle: {
    id: 'profiles.clientProfile.archiveClientTitle',
    defaultMessage: 'Archive client',
  },
  archived: {
    id: 'profiles.clientProfile.archived',
    defaultMessage: 'Archived',
  },
  assignMembership: {
    id: 'profiles.clientProfile.assignMembership',
    defaultMessage: 'Assign',
  },
  assignMembershipTitle: {
    id: 'profiles.clientProfile.assignMembershipTitle',
    defaultMessage: 'Assign Membership',
  },
  assignMembershipToClient: {
    id: 'profiles.clientProfile.assignMembershipToClient',
    defaultMessage: 'Assign membership to client',
  },
  assignTrainer: {
    id: 'profiles.clientProfile.assignTrainer',
    defaultMessage: 'Assign a trainer',
  },
  assignedTrainers: {
    id: 'profiles.clientProfile.assignedTrainers',
    defaultMessage: 'Assigned Trainers',
  },
  assignmentCurrency: {
    id: 'profiles.clientProfile.assignmentCurrency',
    defaultMessage: 'Currency: {currency}',
  },
  assignmentNoTrainer: {
    id: 'profiles.clientProfile.assignmentNoTrainer',
    defaultMessage: 'No trainer',
  },
  assignmentTrainerLabel: {
    id: 'profiles.clientProfile.assignmentTrainerLabel',
    defaultMessage: 'Trainer',
  },
  assignmentTrainerFeePreview: {
    id: 'profiles.clientProfile.assignmentTrainerFeePreview',
    defaultMessage: 'Estimated fee: {amount}',
  },
  assignmentTrainerFeePreviewHint: {
    id: 'profiles.clientProfile.assignmentTrainerFeePreviewHint',
    defaultMessage:
      'A preview of this setting, not an amount earned or payable.',
  },
  assignmentTrainerFeeZeroWarning: {
    id: 'profiles.clientProfile.assignmentTrainerFeeZeroWarning',
    defaultMessage: 'Fee 0 — the money stays with the organization.',
  },
  assignmentTrainerFeeKeepsNothingWarning: {
    id: 'profiles.clientProfile.assignmentTrainerFeeKeepsNothingWarning',
    defaultMessage: 'The organization keeps nothing from this membership.',
  },
  assignmentVisitsLabel: {
    id: 'profiles.clientProfile.assignmentVisitsLabel',
    defaultMessage: 'Number of visits',
  },
  attachNewMembershipAction: {
    id: 'profiles.clientProfile.attachNewMembershipAction',
    defaultMessage: 'Attach new',
  },
  touAcceptanceSelf: {
    id: 'profiles.clientProfile.touAcceptanceSelf',
    defaultMessage: 'Terms of Use v{version} accepted by the client on {date}',
  },
  touAcceptanceStaff: {
    id: 'profiles.clientProfile.touAcceptanceStaff',
    defaultMessage: 'Terms of Use v{version} accepted by {name} on {date}',
  },
  touAcceptanceLapsed: {
    id: 'profiles.clientProfile.touAcceptanceLapsed',
    defaultMessage:
      'The terms have changed since – the new version is awaiting acceptance',
  },
  touAcceptanceNone: {
    id: 'profiles.clientProfile.touAcceptanceNone',
    defaultMessage: 'Terms of Use not accepted yet',
  },
  renewedAutomatically: {
    id: 'profiles.clientProfile.renewedAutomatically',
    defaultMessage: 'Renewed automatically',
  },
  renewedManually: {
    id: 'profiles.clientProfile.renewedManually',
    defaultMessage: 'Renewed manually',
  },
  autoRenewCaptionOff: {
    id: 'profiles.clientProfile.autoRenewCaptionOff',
    defaultMessage: 'Automatic renewal: off',
  },
  autoRenewCaptionOn: {
    id: 'profiles.clientProfile.autoRenewCaptionOn',
    defaultMessage: 'Automatic renewal: on',
  },
  autoRenewCheckboxLabel: {
    id: 'profiles.clientProfile.autoRenewCheckboxLabel',
    defaultMessage: 'Renew automatically',
  },
  autoRenewLockedHint: {
    id: 'profiles.clientProfile.autoRenewLockedHint',
    defaultMessage:
      'Automatic renewal can only be turned on for a cardless recurring membership',
  },
  autoRenewCycleOverHint: {
    id: 'profiles.clientProfile.autoRenewCycleOverHint',
    defaultMessage: 'This cycle is already over — renew it instead',
  },
  autoRenewAlreadyFollowedHint: {
    id: 'profiles.clientProfile.autoRenewAlreadyFollowedHint',
    defaultMessage:
      'This cycle is over and a new one already follows it — edit that one instead',
  },
  autoRenewEndedEarlyHint: {
    id: 'profiles.clientProfile.autoRenewEndedEarlyHint',
    defaultMessage: 'This cycle was ended early — use "Attach new" instead',
  },
  avg: {
    id: 'profiles.clientProfile.avg',
    defaultMessage: 'avg',
  },
  avgPerMonth: {
    id: 'profiles.clientProfile.avgPerMonth',
    defaultMessage: 'Avg / month',
  },
  awaitingActivation: {
    id: 'profiles.clientProfile.awaitingActivation',
    defaultMessage: 'Awaiting activation',
  },
  backToClients: {
    id: 'profiles.clientProfile.backToClients',
    defaultMessage: 'Back to clients',
  },
  cancel: {
    id: 'profiles.clientProfile.cancel',
    defaultMessage: 'Cancel',
  },
  cancelMembership: {
    id: 'profiles.clientProfile.cancelMembership',
    defaultMessage: 'Cancel membership',
  },
  cancelMembershipConfirm: {
    id: 'profiles.clientProfile.cancelMembershipConfirm',
    defaultMessage: 'Cancel membership',
  },
  cancelMembershipDescription: {
    id: 'profiles.clientProfile.cancelMembershipDescription',
    defaultMessage:
      'This cancels the membership right away. Money already paid stays on record — refund it, if owed, from the membership card. This action cannot be undone.',
  },
  cancelMembershipRefundSeparate: {
    id: 'profiles.clientProfile.cancelMembershipRefundSeparate',
    defaultMessage:
      'Cancelling does not return any money. Use "Record executed refund" on this membership to record a refund you have actually made.',
  },
  cancelled: {
    id: 'profiles.clientProfile.cancelled',
    defaultMessage: 'Cancelled',
  },
  checkIn: {
    id: 'profiles.clientProfile.checkIn',
    defaultMessage: 'Check in',
  },
  checkInConfirmButton: {
    id: 'profiles.clientProfile.checkInConfirmButton',
    defaultMessage: 'Confirm check-in',
  },
  checkInLimitReached: {
    id: 'profiles.clientProfile.checkInLimitReached',
    defaultMessage:
      'This membership has reached its workout limit ({limit} {limit, plural, one {workout} other {workouts}}). No more check-ins can be recorded.',
  },
  checkInSuccess: {
    id: 'profiles.clientProfile.checkInSuccess',
    defaultMessage: 'Check-in recorded successfully',
  },
  checkInTitle: {
    id: 'profiles.clientProfile.checkInTitle',
    defaultMessage: 'Confirm Check-In',
  },
  checkInDialogTitle: {
    id: 'profiles.clientProfile.checkInDialogTitle',
    defaultMessage: 'Check-In {name}',
  },
  checkInMembershipLine: {
    id: 'profiles.clientProfile.checkInMembershipLine',
    defaultMessage: 'Membership: {name}',
  },
  checkInUsageSince: {
    id: 'profiles.clientProfile.checkInUsageSince',
    defaultMessage: '{used}/{total} check-ins from {date}',
  },
  checkInTypeLabel: {
    id: 'profiles.clientProfile.checkInTypeLabel',
    defaultMessage: 'Check-In type',
  },
  checkInTypeWithTrainer: {
    id: 'profiles.clientProfile.checkInTypeWithTrainer',
    defaultMessage: 'With trainer',
  },
  checkInTypeSolo: {
    id: 'profiles.clientProfile.checkInTypeSolo',
    defaultMessage: 'Solo',
  },
  checkInTypeTrial: {
    id: 'profiles.clientProfile.checkInTypeTrial',
    defaultMessage: 'Trial',
  },
  checkInClientAt: {
    id: 'profiles.clientProfile.checkInClientAt',
    defaultMessage: 'Checking in {name} at {time}',
  },
  checkInEventLabel: {
    id: 'profiles.clientProfile.checkInEventLabel',
    defaultMessage: 'Booking event',
  },
  checkInEventNone: {
    id: 'profiles.clientProfile.checkInEventNone',
    defaultMessage: 'No event',
  },
  checkInEventOption: {
    id: 'profiles.clientProfile.checkInEventOption',
    defaultMessage: '{time} · {title}',
  },
  checkInEventBooked: {
    id: 'profiles.clientProfile.checkInEventBooked',
    defaultMessage: 'booked',
  },
  checkInEventBookFailed: {
    id: 'profiles.clientProfile.checkInEventBookFailed',
    defaultMessage: 'The client could not be booked into the selected event.',
  },
  checkInEventRefusedFull: {
    id: 'profiles.clientProfile.checkInEventRefusedFull',
    defaultMessage:
      'The selected event is full, so the client cannot be added.',
  },
  checkInEventRefusedInPast: {
    id: 'profiles.clientProfile.checkInEventRefusedInPast',
    defaultMessage:
      'The selected event has already ended, so the client cannot be added.',
  },
  checkInEventRefusedCancelled: {
    id: 'profiles.clientProfile.checkInEventRefusedCancelled',
    defaultMessage: 'The selected event was cancelled.',
  },
  checkInEventRefusedNotFound: {
    id: 'profiles.clientProfile.checkInEventRefusedNotFound',
    defaultMessage: 'The selected event no longer exists.',
  },
  checkInEventRefusedGroup: {
    id: 'profiles.clientProfile.checkInEventRefusedGroup',
    defaultMessage:
      'The selected event is only for certain client groups, and the client is not in any of them.',
  },
  checkInEventRefusedAlreadyBooked: {
    id: 'profiles.clientProfile.checkInEventRefusedAlreadyBooked',
    defaultMessage: 'The client already has a place in the selected event.',
  },
  checkInEventHeldOutsideMembership: {
    id: 'profiles.clientProfile.checkInEventHeldOutsideMembership',
    defaultMessage:
      'The client already has a place in the selected event outside this membership (for example as a trial). Check them in as a trial, or with no event.',
  },
  checkInEventRefusedOverlap: {
    id: 'profiles.clientProfile.checkInEventRefusedOverlap',
    defaultMessage:
      'The client already has a booking at the same time as the selected event.',
  },
  checkInEventRefusedNoVisits: {
    id: 'profiles.clientProfile.checkInEventRefusedNoVisits',
    defaultMessage:
      'The client has no visits left on this membership for the selected event.',
  },
  checkInEventRefusedMembership: {
    id: 'profiles.clientProfile.checkInEventRefusedMembership',
    defaultMessage:
      'This membership does not cover the selected event (check its dates and status).',
  },
  checkInEventRefusedNotMember: {
    id: 'profiles.clientProfile.checkInEventRefusedNotMember',
    defaultMessage: 'The client is not an active member of this organization.',
  },
  checkInTimeLabel: {
    id: 'profiles.clientProfile.checkInTimeLabel',
    defaultMessage: 'Check-In time',
  },
  checkInTimeHelper: {
    id: 'profiles.clientProfile.checkInTimeHelper',
    defaultMessage:
      'Forgot to check them in earlier? Edit the time (today only).',
  },
  checkInVoided: {
    id: 'profiles.clientProfile.checkInVoided',
    defaultMessage: 'Undone',
  },
  duplicateCheckInTitle: {
    id: 'profiles.clientProfile.duplicateCheckInTitle',
    defaultMessage: 'Already checked in today',
  },
  duplicateCheckInBody: {
    id: 'profiles.clientProfile.duplicateCheckInBody',
    defaultMessage:
      'This membership was already checked in today at {time} by {author}.',
  },
  duplicateCheckInConfirmButton: {
    id: 'profiles.clientProfile.duplicateCheckInConfirmButton',
    defaultMessage: 'Check in anyway',
  },
  checkInFromBooking: {
    id: 'profiles.clientProfile.checkInFromBooking',
    defaultMessage: 'From booking',
  },
  // Task 4 (membership-renewal plan) — the PO's "check-in for self-training"
  // option: a walk-in check-in recorded without spending a visit off the
  // package (`consumesVisit: false`).
  checkInNoVisit: {
    id: 'profiles.clientProfile.checkInNoVisit',
    defaultMessage: 'Without using a session',
  },
  checkInTrialLabel: {
    id: 'profiles.clientProfile.checkInTrialLabel',
    defaultMessage: 'Trial workout',
  },
  checkInSelf: {
    id: 'profiles.clientProfile.checkInSelf',
    defaultMessage: 'Self check-in',
  },
  checkInsAction: {
    id: 'profiles.clientProfile.checkInsAction',
    defaultMessage: 'Check-ins',
  },
  checkInsEmpty: {
    id: 'profiles.clientProfile.checkInsEmpty',
    defaultMessage: 'No check-ins recorded yet.',
  },
  checkInsTitle: {
    id: 'profiles.clientProfile.checkInsTitle',
    defaultMessage: 'Check-in history',
  },
  close: {
    id: 'profiles.clientProfile.close',
    defaultMessage: 'Close',
  },
  comingSoon: {
    id: 'profiles.clientProfile.comingSoon',
    defaultMessage: 'coming soon',
  },
  comparePerformance: {
    id: 'profiles.clientProfile.comparePerformance',
    defaultMessage: 'Compare Performance',
  },
  completed: {
    id: 'profiles.clientProfile.completed',
    defaultMessage: 'Completed',
  },
  connectionDate: {
    id: 'profiles.clientProfile.connectionDate',
    defaultMessage: 'Connection date',
  },
  consumed: {
    id: 'profiles.clientProfile.consumed',
    defaultMessage: 'Consumed',
  },
  createNew: {
    id: 'profiles.clientProfile.createNew',
    defaultMessage: 'New membership',
  },
  day: {
    id: 'profiles.clientProfile.day',
    defaultMessage: 'Day',
  },
  scheduleActivationClear: {
    id: 'profiles.clientProfile.scheduleActivationClear',
    defaultMessage: 'Remove scheduled date',
  },
  endDateAuto: {
    id: 'profiles.clientProfile.endDateAuto',
    defaultMessage: 'AUTO',
  },
  endDatePlaceholder: {
    id: 'profiles.clientProfile.endDatePlaceholder',
    defaultMessage: 'Select membership first',
  },
  membershipCountNoun: {
    id: 'profiles.clientProfile.membershipCountNoun',
    defaultMessage: '{count, plural, one {membership} other {memberships}}',
  },
  durationMonths: {
    id: 'profiles.clientProfile.durationMonths',
    defaultMessage: '{count, plural, one {# month} other {# months}}',
  },
  durationWeeks: {
    id: 'profiles.clientProfile.durationWeeks',
    defaultMessage: '{count, plural, one {# week} other {# weeks}}',
  },
  durationDays: {
    id: 'profiles.clientProfile.durationDays',
    defaultMessage: '{count, plural, one {# day} other {# days}}',
  },
  daysLeft: {
    id: 'profiles.clientProfile.daysLeft',
    defaultMessage: '{count, plural, one {# day left} other {# days left}}',
  },
  deleteAccountConfirmDescription: {
    id: 'profiles.clientProfile.deleteAccountConfirmDescription',
    defaultMessage:
      'This will permanently delete this account and erase all personal data. Anonymised usage data will be retained for analytics. This action cannot be undone.',
  },
  deleteAccountConfirmTitle: {
    id: 'profiles.clientProfile.deleteAccountConfirmTitle',
    defaultMessage: 'Delete account?',
  },
  deleteAccountDescription: {
    id: 'profiles.clientProfile.deleteAccountDescription',
    defaultMessage: 'Permanently erase personal data and disable this account.',
  },
  deleteAccountTitle: {
    id: 'profiles.clientProfile.deleteAccountTitle',
    defaultMessage: 'Delete account',
  },
  disconnectBlockedTrainerDescription: {
    id: 'profiles.clientProfile.disconnectBlockedTrainerDescription',
    defaultMessage:
      "You can't disconnect because you are a trainer in all of your organizations.",
  },
  disconnectBlockedTrainerTitle: {
    id: 'profiles.clientProfile.disconnectBlockedTrainerTitle',
    defaultMessage: "Can't disconnect",
  },
  disconnectConfirmDescription: {
    id: 'profiles.clientProfile.disconnectConfirmDescription',
    defaultMessage:
      'Are you sure you want to disconnect this client from the organization?',
  },
  disconnectConfirmTitle: {
    id: 'profiles.clientProfile.disconnectConfirmTitle',
    defaultMessage: 'Disconnect client?',
  },
  disconnectFromOrganization: {
    id: 'profiles.clientProfile.disconnectFromOrganization',
    defaultMessage: 'Disconnect from organization',
  },
  disconnectFromOrganizationDescription: {
    id: 'profiles.clientProfile.disconnectFromOrganizationDescription',
    defaultMessage: "Revoke this client's access to your organization.",
  },
  disconnectSelfConfirmDescription: {
    id: 'profiles.clientProfile.disconnectSelfConfirmDescription',
    defaultMessage: 'Select an organization to disconnect your account from.',
  },
  discountAmount: {
    id: 'profiles.clientProfile.discountAmount',
    defaultMessage: 'Discount amount',
  },
  discountPercent: {
    id: 'profiles.clientProfile.discountPercent',
    defaultMessage: 'Discount (%)',
  },
  discountSummary: {
    id: 'profiles.clientProfile.discountSummary',
    defaultMessage: '{discount}% off — original {original}{currency}',
  },
  documents: {
    id: 'profiles.clientProfile.documents',
    defaultMessage: 'Documents',
  },
  done: {
    id: 'profiles.clientProfile.done',
    defaultMessage: 'Done',
  },
  duration: {
    id: 'profiles.clientProfile.duration',
    defaultMessage: 'Duration',
  },
  edit: {
    id: 'profiles.clientProfile.edit',
    defaultMessage: 'Edit',
  },
  pendingInvitationReadOnly: {
    id: 'features.clientProfile.pendingInvitationReadOnly',
    defaultMessage:
      'The client has not accepted the invitation yet — changes are possible once they accept.',
  },
  editClient: {
    id: 'profiles.clientProfile.editClient',
    defaultMessage: 'Edit client',
  },
  clientReadOnlyNote: {
    id: 'profiles.clientProfile.clientReadOnlyNote',
    defaultMessage: 'Former client — view only',
  },
  editMembership: {
    id: 'profiles.clientProfile.editMembership',
    defaultMessage: 'Edit membership',
  },
  editMembershipVisitsValue: {
    id: 'profiles.clientProfile.editMembershipVisitsValue',
    defaultMessage: 'Visits: {count}',
  },
  editPackageLockedHint: {
    id: 'profiles.clientProfile.editPackageLockedHint',
    defaultMessage:
      'Package and price don’t change on an assigned membership. To change them, cancel it and assign a new one, or use Replace.',
  },
  editPackageLockedHintNoReplace: {
    id: 'profiles.clientProfile.editPackageLockedHintNoReplace',
    defaultMessage:
      'Package and price don’t change on an assigned membership. To change them, cancel it and assign a new one.',
  },
  startDateLockedByVisits: {
    id: 'profiles.clientProfile.startDateLockedByVisits',
    defaultMessage: 'Locked: the membership already has visits.',
  },
  startDateLockedByEarlyEnd: {
    id: 'profiles.clientProfile.startDateLockedByEarlyEnd',
    defaultMessage: 'Locked: this cycle was ended early.',
  },
  startDateLockedBySubscription: {
    id: 'profiles.clientProfile.startDateLockedBySubscription',
    defaultMessage: 'Locked: the membership has an active subscription.',
  },
  edited: {
    id: 'profiles.clientProfile.edited',
    defaultMessage: 'Edited {date}',
  },
  enableMembership: {
    id: 'profiles.clientProfile.enableMembership',
    defaultMessage: 'Enable',
  },
  enableMembershipConfirm: {
    id: 'profiles.clientProfile.enableMembershipConfirm',
    defaultMessage: 'Enable this membership?',
  },
  enableMembershipDescription: {
    id: 'profiles.clientProfile.enableMembershipDescription',
    defaultMessage:
      "The client hasn't linked a payment card yet. Enabling it now lets them use the membership before payment is confirmed.",
  },
  endDate: {
    id: 'profiles.clientProfile.endDate',
    defaultMessage: 'End date',
  },
  endCycleAction: {
    id: 'profiles.clientProfile.endCycleAction',
    defaultMessage: 'End cycle',
  },
  endCycleChargeFull: {
    id: 'profiles.clientProfile.endCycleChargeFull',
    defaultMessage: 'Charge the full package',
  },
  endCycleCollected: {
    id: 'profiles.clientProfile.endCycleCollected',
    defaultMessage: 'Collected so far: {amount}',
  },
  endCycleConfirmButton: {
    id: 'profiles.clientProfile.endCycleConfirmButton',
    defaultMessage: 'End cycle today',
  },
  endCycleDescription: {
    id: 'profiles.clientProfile.endCycleDescription',
    defaultMessage:
      'The cycle ends today and does not renew. Its visits, bookings and payments stay as they are; a reduction is recorded as a discount, and money back is a separate refund.',
  },
  endCycleDue: {
    id: 'profiles.clientProfile.endCycleDue',
    defaultMessage: 'Still due: {amount}',
  },
  endCycleInEffect: {
    id: 'profiles.clientProfile.endCycleInEffect',
    defaultMessage: 'Price in effect: {amount}',
  },
  endCyclePackageFallback: {
    id: 'profiles.clientProfile.endCyclePackageFallback',
    defaultMessage: 'This membership',
  },
  endCycleReason: {
    id: 'profiles.clientProfile.endCycleReason',
    defaultMessage: 'Reason for the reduction',
  },
  endCycleReduce: {
    id: 'profiles.clientProfile.endCycleReduce',
    defaultMessage: 'Reduce to',
  },
  endCycleReducedAmount: {
    id: 'profiles.clientProfile.endCycleReducedAmount',
    defaultMessage: 'Amount ({currency})',
  },
  endCycleSessionsUsed: {
    id: 'profiles.clientProfile.endCycleSessionsUsed',
    defaultMessage: 'Visits used: {used} of {total}',
  },
  endCycleTitle: {
    id: 'profiles.clientProfile.endCycleTitle',
    defaultMessage: 'End the cycle today',
  },
  /**
   * Item 6 (Task 3 residuals brief) — ending today when a scheduled Replace
   * successor exists leaves the client with no active membership until the
   * successor starts. "End cycle" is still offered in this state
   * (`onEndCycle` is not gated on `hasSuccessor` — unlike Replace/Replace
   * now, which the card hides once one exists).
   */
  endCycleReplacementGapWarning: {
    id: 'profiles.clientProfile.endCycleReplacementGapWarning',
    defaultMessage:
      'A replacement starts on {date}; the client will have no active membership between today and then.',
  },
  expired: {
    id: 'profiles.clientProfile.expired',
    defaultMessage: 'Expired',
  },
  expiringSoon: {
    id: 'profiles.clientProfile.expiringSoon',
    defaultMessage: 'Expiring soon',
  },
  exportData: {
    id: 'profiles.clientProfile.exportData',
    defaultMessage: 'Export',
  },
  finalPrice: {
    id: 'profiles.clientProfile.finalPrice',
    defaultMessage: 'Final price',
  },
  fitnessScore: {
    id: 'profiles.clientProfile.fitnessScore',
    defaultMessage: 'Fitness Score',
  },
  pause: {
    id: 'profiles.clientProfile.pause',
    defaultMessage: 'Pause',
  },
  pauseMembershipConfirm: {
    id: 'profiles.clientProfile.pauseMembershipConfirm',
    defaultMessage: 'Pause membership',
  },
  pauseMembershipDescription: {
    id: 'profiles.clientProfile.pauseMembershipDescription',
    defaultMessage:
      'The paused days will be added back to the membership once it ends — the client keeps every day they paid for.',
  },
  pauseUntilPreview: {
    id: 'profiles.clientProfile.pauseUntilPreview',
    defaultMessage: 'Paused until {date}',
  },
  freezeWindow: {
    id: 'profiles.clientProfile.freezeWindow',
    defaultMessage: 'From {from} until {to}',
  },
  paused: {
    id: 'profiles.clientProfile.paused',
    defaultMessage: 'Paused',
  },
  frozenDays: {
    id: 'profiles.clientProfile.frozenDays',
    defaultMessage: 'Number of days',
  },
  from: {
    id: 'profiles.clientProfile.from',
    defaultMessage: 'From',
  },
  fullName: {
    id: 'profiles.clientProfile.fullName',
    defaultMessage: 'Full name',
  },
  groups: {
    id: 'profiles.clientProfile.groups',
    defaultMessage: 'Groups',
  },
  high: {
    id: 'profiles.clientProfile.high',
    defaultMessage: 'high',
  },
  loadMore: {
    id: 'profiles.clientProfile.loadMore',
    defaultMessage: 'Load more',
  },
  loading: {
    id: 'profiles.clientProfile.loading',
    defaultMessage: 'Loading...',
  },
  low: {
    id: 'profiles.clientProfile.low',
    defaultMessage: 'low',
  },
  // Task 8 (membership-renewal plan) — "Uplaćeno?": opens the manual
  // payment prefilled with the amount still due.
  markPaid: {
    id: 'profiles.clientProfile.markPaid',
    defaultMessage: 'Paid?',
  },
  meals: {
    id: 'profiles.clientProfile.meals',
    defaultMessage: 'Meals',
  },
  membership: {
    id: 'profiles.clientProfile.membership',
    defaultMessage: 'Membership',
  },
  membershipAndGroups: {
    id: 'profiles.clientProfile.membershipAndGroups',
    defaultMessage: 'Membership & Groups',
  },
  membershipRecurrenceType: {
    id: 'profiles.clientProfile.membershipRecurrenceType',
    defaultMessage: 'Billing',
  },
  membershipStatus: {
    id: 'profiles.clientProfile.membershipStatus',
    defaultMessage: 'Membership Status',
  },
  membershipSummaryIncomplete: {
    id: 'profiles.clientProfile.membershipSummaryIncomplete',
    defaultMessage:
      'Ledger-recorded payments; historical records are incomplete.',
  },
  membershipSummaryUnavailable: {
    id: 'profiles.clientProfile.membershipSummaryUnavailable',
    defaultMessage: 'Totals could not be loaded.',
  },
  membershipSummaryValueNote: {
    id: 'profiles.clientProfile.membershipSummaryValueNote',
    defaultMessage:
      'Value is the contract value in the membership type’s current currency, not a historical payment total.',
  },
  membershipSummaryValueUnavailable: {
    id: 'profiles.clientProfile.membershipSummaryValueUnavailable',
    defaultMessage: 'Contract value is not available in this currency.',
  },
  membershipTypeFilterLabel: {
    id: 'profiles.clientProfile.membershipTypeFilterLabel',
    defaultMessage: 'Membership type',
  },
  missed: {
    id: 'profiles.clientProfile.missed',
    defaultMessage: 'Missed',
  },
  mode: {
    id: 'profiles.clientProfile.mode',
    defaultMessage: 'Mode',
  },
  month: {
    id: 'profiles.clientProfile.month',
    defaultMessage: 'Month',
  },
  noAssignedTrainers: {
    id: 'profiles.clientProfile.noAssignedTrainers',
    defaultMessage: 'No assigned Trainers',
  },
  noAvailableGroups: {
    id: 'profiles.clientProfile.noAvailableGroups',
    defaultMessage: 'No groups available',
  },
  noClientMemberships: {
    id: 'profiles.clientProfile.noClientMemberships',
    defaultMessage: 'No memberships assigned yet',
  },
  noGroups: {
    id: 'profiles.clientProfile.noGroups',
    defaultMessage: 'This client is not in any groups yet.',
  },
  noMembers: {
    id: 'profiles.clientProfile.noMembers',
    defaultMessage: 'No members in this group.',
  },
  noMemberships: {
    id: 'profiles.clientProfile.noMemberships',
    defaultMessage: 'No memberships',
  },
  noMembershipsMatchFilters: {
    id: 'profiles.clientProfile.noMembershipsMatchFilters',
    defaultMessage: 'No memberships match the selected filters',
  },
  // Distinct from `noMemberships` ("this client holds none") on purpose: this
  // one is the ASSIGN dropdown's empty state, where the organization itself has
  // no plan to assign, and the way out is creating one.
  noMembershipPlans: {
    id: 'profiles.clientProfile.noMembershipPlans',
    defaultMessage: 'No membership plans yet — create one first',
  },
  notes: {
    id: 'profiles.clientProfile.notes',
    defaultMessage: 'Notes',
  },
  noNotesYet: {
    id: 'profiles.clientProfile.noNotesYet',
    defaultMessage: 'No notes yet',
  },
  openFullWorkoutHistory: {
    id: 'profiles.clientProfile.openFullWorkoutHistory',
    defaultMessage: 'Open full workout history',
  },
  originalPrice: {
    id: 'profiles.clientProfile.originalPrice',
    defaultMessage: 'Original price',
  },
  paid: {
    id: 'profiles.clientProfile.paid',
    defaultMessage: 'Paid',
  },
  past: {
    id: 'profiles.clientProfile.past',
    defaultMessage: 'Past',
  },
  paymentAmount: {
    id: 'profiles.clientProfile.paymentAmount',
    defaultMessage: 'Amount',
  },
  paymentCurrency: {
    id: 'profiles.clientProfile.paymentCurrency',
    defaultMessage: 'Currency',
  },
  paymentDate: {
    id: 'profiles.clientProfile.paymentDate',
    defaultMessage: 'Payment date & time',
  },
  paymentNote: {
    id: 'profiles.clientProfile.paymentNote',
    defaultMessage: 'Note',
  },
  // Task 8 — the cycle's payment state, as the server states it.
  paymentStatePaid: {
    id: 'profiles.clientProfile.paymentStatePaid',
    defaultMessage: 'Paid',
  },
  paymentStatePartial: {
    id: 'profiles.clientProfile.paymentStatePartial',
    defaultMessage: 'Partly paid',
  },
  paymentStateUnknown: {
    id: 'profiles.clientProfile.paymentStateUnknown',
    defaultMessage: 'Payment unknown',
  },
  paymentStateUnpaid: {
    id: 'profiles.clientProfile.paymentStateUnpaid',
    defaultMessage: 'Not paid',
  },
  paymentType: {
    id: 'profiles.clientProfile.paymentType',
    defaultMessage: 'Payment type',
  },
  paymentTypeCard: {
    id: 'profiles.clientProfile.paymentTypeCard',
    defaultMessage: 'Card',
  },
  paymentTypeCash: {
    id: 'profiles.clientProfile.paymentTypeCash',
    defaultMessage: 'Cash',
  },
  paymentTypeOther: {
    id: 'profiles.clientProfile.paymentTypeOther',
    defaultMessage: 'Other',
  },
  paymentTypeTransfer: {
    id: 'profiles.clientProfile.paymentTypeTransfer',
    defaultMessage: 'Transfer',
  },
  paymentsCollapse: {
    id: 'profiles.clientProfile.paymentsCollapse',
    defaultMessage: 'Show less',
  },
  paymentsExpand: {
    id: 'profiles.clientProfile.paymentsExpand',
    defaultMessage: '+{count} more',
  },
  pending: {
    id: 'profiles.clientProfile.pending',
    defaultMessage: 'Pending',
  },
  firstChargeOn: {
    id: 'profiles.clientProfile.firstChargeOn',
    defaultMessage: 'First charge on {start}',
  },
  pendingPaymentMethod: {
    id: 'profiles.clientProfile.pendingPaymentMethod',
    defaultMessage: 'Awaiting payment method',
  },
  percentOfPeriod: {
    id: 'profiles.clientProfile.percentOfPeriod',
    defaultMessage: '{percent}% of period',
  },
  performance: {
    id: 'profiles.clientProfile.performance',
    defaultMessage: 'Performance',
  },
  personalData: {
    id: 'profiles.clientProfile.personalData',
    defaultMessage: 'Personal Data',
  },
  pricing: {
    id: 'profiles.clientProfile.pricing',
    defaultMessage: 'Pricing',
  },
  progressPhotos: {
    id: 'profiles.clientProfile.progressPhotos',
    defaultMessage: 'Progress Photos',
  },
  records: {
    id: 'profiles.clientProfile.records',
    defaultMessage: 'Records',
  },
  recurringMembership: {
    id: 'profiles.clientProfile.recurringMembership',
    defaultMessage: 'Recurring',
  },
  refunded: {
    id: 'profiles.clientProfile.refunded',
    defaultMessage: 'Refunded',
  },
  remove: {
    id: 'profiles.clientProfile.remove',
    defaultMessage: 'Remove',
  },
  removeConfirmDescription: {
    id: 'profiles.clientProfile.removeConfirmDescription',
    defaultMessage: 'Remove this client from "{name}"?',
  },
  removeConfirmTitle: {
    id: 'profiles.clientProfile.removeConfirmTitle',
    defaultMessage: 'Remove from group',
  },
  removeFromGroup: {
    id: 'profiles.clientProfile.removeFromGroup',
    defaultMessage: 'Remove from group',
  },
  renewMembershipAlreadyRenewed: {
    id: 'profiles.clientProfile.renewMembershipAlreadyRenewed',
    defaultMessage: 'Already renewed',
  },
  renewMembershipConfirmButton: {
    id: 'profiles.clientProfile.renewMembershipConfirmButton',
    defaultMessage: 'Renew',
  },
  renewMembershipDescription: {
    id: 'profiles.clientProfile.renewMembershipDescription',
    defaultMessage:
      'A new cycle of this membership, at the same package price and with the same trainer. The visits and the discount may be corrected.',
  },
  renewMembershipFromRegularDate: {
    id: 'profiles.clientProfile.renewMembershipFromRegularDate',
    defaultMessage: 'From the regular renewal date ({date})',
  },
  renewMembershipFromToday: {
    id: 'profiles.clientProfile.renewMembershipFromToday',
    defaultMessage: 'From today',
  },
  renewMembershipPackagePrice: {
    id: 'profiles.clientProfile.renewMembershipPackagePrice',
    defaultMessage: 'Package price: {price}',
  },
  renewMembershipStartsOn: {
    id: 'profiles.clientProfile.renewMembershipStartsOn',
    defaultMessage: 'The new cycle starts on {date}',
  },
  renewMembershipTitle: {
    id: 'profiles.clientProfile.renewMembershipTitle',
    defaultMessage: 'Renew the same membership',
  },
  renewMembershipTrainerValue: {
    id: 'profiles.clientProfile.renewMembershipTrainerValue',
    defaultMessage: 'Trainer: {name}',
  },
  renewMembershipVisitsHint: {
    id: 'profiles.clientProfile.renewMembershipVisitsHint',
    defaultMessage:
      'The visits are used up, so the new cycle starts on the day of the next visit and the current one ends then. Pick a day before {date}.',
  },
  renewSameAction: {
    id: 'profiles.clientProfile.renewSameAction',
    defaultMessage: 'Renew same',
  },
  renewalUpForRenewalDate: {
    id: 'profiles.clientProfile.renewalUpForRenewalDate',
    defaultMessage: 'Up for renewal · date expired',
  },
  renewalUpForRenewalVisits: {
    id: 'profiles.clientProfile.renewalUpForRenewalVisits',
    defaultMessage: 'Up for renewal · visits used up',
  },
  replaceMembership: {
    id: 'profiles.clientProfile.replaceMembership',
    defaultMessage: 'Replace membership',
  },
  replaceMembershipAction: {
    id: 'profiles.clientProfile.replaceMembershipAction',
    defaultMessage: 'Replace from next cycle',
  },
  replaceNowAction: {
    id: 'profiles.clientProfile.replaceNowAction',
    defaultMessage: 'Replace now',
  },
  replaceNowNotice: {
    id: 'profiles.clientProfile.replaceNowNotice',
    defaultMessage:
      '"{name}" ends today and the new membership starts today. Visits, bookings and payments of the current cycle stay on it.',
  },
  replaceNowOldCycleLabel: {
    id: 'profiles.clientProfile.replaceNowOldCycleLabel',
    defaultMessage: 'The current cycle',
  },
  replaceNowTitle: {
    id: 'profiles.clientProfile.replaceNowTitle',
    defaultMessage: 'Replace now',
  },
  replaceMembershipTitle: {
    id: 'profiles.clientProfile.replaceMembershipTitle',
    defaultMessage: 'Replace membership',
  },
  replacingMembershipNotice: {
    id: 'profiles.clientProfile.replacingMembershipNotice',
    defaultMessage:
      'Replacing "{name}", which ends {endDate} — the new membership starts the same day, with no gap and no overlap.',
  },
  membershipReplacesNotice: {
    id: 'profiles.clientProfile.membershipReplacesNotice',
    defaultMessage: 'Replaces the membership ending {endDate}',
  },
  membershipCorrectedBy: {
    id: 'profiles.clientProfile.membershipCorrectedBy',
    defaultMessage: 'Corrected by: {name}, {date}',
  },
  membershipTrainer: {
    id: 'profiles.clientProfile.membershipTrainer',
    defaultMessage: 'Trainer: {name}',
  },
  membershipTrainerFee: {
    id: 'profiles.clientProfile.membershipTrainerFee',
    defaultMessage: 'Trainer fee: {fee}',
  },
  membershipStartsOn: {
    id: 'profiles.clientProfile.membershipStartsOn',
    defaultMessage: 'Starts on {date}',
  },
  membershipReplacedByNotice: {
    id: 'profiles.clientProfile.membershipReplacedByNotice',
    defaultMessage: 'Already replaced — a new membership starts {startDate}',
  },
  requiresCardLinkNow: {
    id: 'profiles.clientProfile.requiresCardLinkNow',
    defaultMessage: 'Require a linked card at assignment',
  },
  // Task 8 (Decision 6) — paying less than is due asks what the rest is.
  shortfallDebt: {
    id: 'profiles.clientProfile.shortfallDebt',
    defaultMessage: 'a debt',
  },
  shortfallDiscount: {
    id: 'profiles.clientProfile.shortfallDiscount',
    defaultMessage: 'a discount (client owes nothing)',
  },
  shortfallDiscountConfirm: {
    id: 'profiles.clientProfile.shortfallDiscountConfirm',
    defaultMessage: 'Record discount',
  },
  shortfallPrompt: {
    id: 'profiles.clientProfile.shortfallPrompt',
    defaultMessage: 'The remaining {amount} is:',
  },
  shortfallReason: {
    id: 'profiles.clientProfile.shortfallReason',
    defaultMessage: 'Reason for the discount',
  },
  save: {
    id: 'profiles.clientProfile.saveChanges',
    defaultMessage: 'Save',
  },
  scheduled: {
    id: 'profiles.clientProfile.scheduled',
    defaultMessage: 'Scheduled',
  },
  scheduleActivationAction: {
    id: 'profiles.clientProfile.scheduleActivationAction',
    defaultMessage: 'Schedule activation',
  },
  resendCardSetupAction: {
    id: 'profiles.clientProfile.resendCardSetupAction',
    defaultMessage: 'Send the card request again',
  },
  resendCardSetupSent: {
    id: 'profiles.clientProfile.resendCardSetupSent',
    defaultMessage:
      'The client was sent the card request again and has another 72 hours',
  },
  scheduleActivationConfirmButton: {
    id: 'profiles.clientProfile.scheduleActivationConfirmButton',
    defaultMessage: 'Schedule',
  },
  scheduleActivationDescription: {
    id: 'profiles.clientProfile.scheduleActivationDescription',
    defaultMessage:
      "On this date the app will try to charge the client's saved card for the first time. If there is no card yet, staff will be notified instead of retrying silently.",
  },
  scheduleActivationTitle: {
    id: 'profiles.clientProfile.scheduleActivationTitle',
    defaultMessage: 'Schedule first charge attempt',
  },
  scheduledActivationNotice: {
    id: 'profiles.clientProfile.scheduledActivationNotice',
    defaultMessage: 'First charge attempt scheduled for {date}',
  },
  selectGroup: {
    id: 'profiles.clientProfile.selectGroup',
    defaultMessage: 'Select group',
  },
  selectMembership: {
    id: 'profiles.clientProfile.selectMembership',
    defaultMessage: 'Select membership',
  },
  sessions: {
    id: 'profiles.clientProfile.sessions',
    defaultMessage: 'Sessions',
  },
  singleMembership: {
    id: 'profiles.clientProfile.singleMembership',
    defaultMessage: 'Single',
  },
  startDate: {
    id: 'profiles.clientProfile.startDate',
    defaultMessage: 'Start date',
  },
  tags: {
    id: 'profiles.clientProfile.tags',
    defaultMessage: 'Tags',
  },
  to: {
    id: 'profiles.clientProfile.to',
    defaultMessage: 'To',
  },
  totalValuePaid: {
    id: 'profiles.clientProfile.totalValuePaid',
    defaultMessage: 'Value / Paid',
  },
  trainerNotes: {
    id: 'profiles.clientProfile.trainerNotes',
    defaultMessage: 'Trainer Notes',
  },
  trainersCount: {
    id: 'profiles.clientProfile.trainersCount',
    defaultMessage: '{count} trainers',
  },
  undoRenewalAction: {
    id: 'profiles.clientProfile.undoRenewalAction',
    defaultMessage: 'Undo renewal',
  },
  undoRenewalConfirm: {
    id: 'profiles.clientProfile.undoRenewalConfirm',
    defaultMessage: 'Undo renewal',
  },
  undoRenewalDescription: {
    id: 'profiles.clientProfile.undoRenewalDescription',
    defaultMessage:
      'This renewal cycle is removed and automatic renewal is switched off for this membership. The previous cycle stays as it was.',
  },
  undoRenewalTitle: {
    id: 'profiles.clientProfile.undoRenewalTitle',
    defaultMessage: 'Undo this automatic renewal?',
  },
  unarchive: {
    id: 'profiles.clientProfile.unarchive',
    defaultMessage: 'Unarchive',
  },
  // Task 5 (membership-renewal plan) — the used-up-choices dialog offered
  // instead of a dead end when staff check a client in, or add them to a
  // class, on a membership whose visits are used up.
  usedUpDialogTitle: {
    id: 'profiles.clientProfile.usedUpDialogTitle',
    defaultMessage: 'No visits left in "{membershipName}" until {endDate}',
  },
  usedUpDialogNewCycle: {
    id: 'profiles.clientProfile.usedUpDialogNewCycle',
    defaultMessage: 'Start a new cycle from {day}',
  },
  usedUpDialogNewCycleHint: {
    id: 'profiles.clientProfile.usedUpDialogNewCycleHint',
    defaultMessage:
      'Copies the price, discount, visits and trainer of this membership.',
  },
  usedUpDialogDayTicket: {
    id: 'profiles.clientProfile.usedUpDialogDayTicket',
    defaultMessage: 'Day ticket',
  },
  usedUpDialogDayTicketPackage: {
    id: 'profiles.clientProfile.usedUpDialogDayTicketPackage',
    defaultMessage: 'One-day package',
  },
  usedUpDialogDayTicketDiscount: {
    id: 'profiles.clientProfile.usedUpDialogDayTicketDiscount',
    defaultMessage: 'Discount %',
  },
  usedUpDialogDayTicketPrice: {
    id: 'profiles.clientProfile.usedUpDialogDayTicketPrice',
    defaultMessage: 'Price: {price}',
  },
  usedUpDialogNoOneDayPackage: {
    id: 'profiles.clientProfile.usedUpDialogNoOneDayPackage',
    defaultMessage: 'No one-day package — create one on the Packages page',
  },
  usedUpDialogPackagesPageLink: {
    id: 'profiles.clientProfile.usedUpDialogPackagesPageLink',
    defaultMessage: 'Packages page',
  },
  usedUpDialogNoVisit: {
    id: 'profiles.clientProfile.usedUpDialogNoVisit',
    defaultMessage: 'Record visit without using a session',
  },
  usedUpDialogNoMembership: {
    id: 'profiles.clientProfile.usedUpDialogNoMembership',
    defaultMessage: 'Book without membership (pay on site)',
  },
  usedUpDialogAlreadyRenewed: {
    id: 'profiles.clientProfile.usedUpDialogAlreadyRenewed',
    defaultMessage: 'Already renewed — retrying on the new cycle.',
  },
  usedUpDialogConfirm: {
    id: 'profiles.clientProfile.usedUpDialogConfirm',
    defaultMessage: 'Confirm',
  },
  validUntil: {
    id: 'profiles.clientProfile.validUntil',
    defaultMessage: 'Valid until',
  },
  visitsLabel: {
    id: 'profiles.clientProfile.visitsLabel',
    defaultMessage: 'Visits',
  },
  visitsUsedThisPeriodWithLimit: {
    id: 'profiles.clientProfile.visitsUsedThisPeriodWithLimit',
    defaultMessage: '{used} / {total} visits used this period',
  },
  visitsUsedWithLimit: {
    id: 'profiles.clientProfile.visitsUsedWithLimit',
    defaultMessage: '{used} / {total} visits used',
  },
  voidCheckInAction: {
    id: 'profiles.clientProfile.voidCheckInAction',
    defaultMessage: 'Undo check-in',
  },
  voidCheckInConfirmButton: {
    id: 'profiles.clientProfile.voidCheckInConfirmButton',
    defaultMessage: 'Undo check-in',
  },
  voidCheckInSuccess: {
    id: 'profiles.clientProfile.voidCheckInSuccess',
    defaultMessage: 'Check-in undone',
  },
  voidCheckInTitle: {
    id: 'profiles.clientProfile.voidCheckInTitle',
    defaultMessage: 'Undo this check-in?',
  },
  voidCheckInWarning: {
    id: 'profiles.clientProfile.voidCheckInWarning',
    defaultMessage:
      'The session will be given back to this membership, and staff will be notified. This action cannot be undone.',
  },
  voidPaymentAction: {
    id: 'profiles.clientProfile.voidPaymentAction',
    defaultMessage: 'Void payment',
  },
  voidPaymentConfirmButton: {
    id: 'profiles.clientProfile.voidPaymentConfirmButton',
    defaultMessage: 'Void payment',
  },
  voidPaymentSuccess: {
    id: 'profiles.clientProfile.voidPaymentSuccess',
    defaultMessage: 'Payment voided',
  },
  voidPaymentTitle: {
    id: 'profiles.clientProfile.voidPaymentTitle',
    defaultMessage: 'Void this payment?',
  },
  voidPaymentWarning: {
    id: 'profiles.clientProfile.voidPaymentWarning',
    defaultMessage:
      'The payment will be removed from the list and reversed in the financial statistics. This action cannot be undone.',
  },
  volume: {
    id: 'profiles.clientProfile.volume',
    defaultMessage: 'Volume',
  },
  week: {
    id: 'profiles.clientProfile.week',
    defaultMessage: 'Week',
  },
  workoutScore7Day: {
    id: 'profiles.clientProfile.workoutScore7Day',
    defaultMessage: 'Workout Score · 7-Day',
  },
  workouts: {
    id: 'profiles.clientProfile.workouts',
    defaultMessage: 'Workouts',
  },
  /**
   * Item 5 (Task 3 residuals brief) — "Paid?" re-reads the due amount before
   * opening the payment dialog; a failed refetch must not open it with a
   * STALE amount already in hand.
   */
  markPaidRefreshError: {
    id: 'profiles.clientProfile.markPaidRefreshError',
    defaultMessage: 'Could not refresh the amount due. Please try again.',
  },
});

export default messages;
